import "./Header.css";

export default function Header() {

    function goToStore() {
        window.location.href = 'https://www.oculus.com/experiences/quest/5036822016365012/';
    }

    return (
        <div className="header">
            <span className="title">Remain Alive</span>
            <span>
                <button type="button" className="button-6" onClick={() => goToStore()}>BUY NOW</button>
            </span>
        </div>
    )
}